export const formGroupStyle = {
  paddingLeft: "1rem",
  paddingRight: "1rem",
  paddingTop: 0,
  paddingBottom: ".5rem"
};
export default formGroupStyle;
